const DedicatedServices = [
  {
    title: 'Dedicated Virtual Assistant',
    subTitle: 'Number of Agents Required: 1 - 10',
    features: [
      'Dedicated Virtual Assistant',
      'Native English Speakers',
      '40-160 hrs per agent / month',
      'Email, Phone, Chat, SMS Support',
      'Available Mon-Sat: 8:30am – 5pm',
      'Our Dedicated Virtual Assistant is perfect for the busy professional looking to add some support to their staff or some extra help in their personal life.',
    ],
    price: 'US$280.00',
    duration: 'for 40 hours',
    type: 'dedicated',
    subtype: 'DEDICATED_VIRT',
  },
  {
    title: 'Dedicated IT Technical Support',
    subTitle: 'Number of Agents Required: 1 - 10',
    features: [
      'Dedicated Virtual Assistant',
      'Native English Speakers',
      '40-160 hrs per agent / month',
      'Email, Phone, Chat, SMS Support',
      'Available Mon-Sat: 8:30am – 5pm',
      'Our Dedicated Virtual Assistant is perfect for the busy professional looking to add some support to their staff or some extra help in their personal life.',
    ],
    price: 'US$340.00',
    duration: 'for 40 hours',
    type: 'dedicated',
    subtype: 'DEDICATED_PROF',
  },
]

export default DedicatedServices
